import React, { useState } from 'react';
import { ChevronDown, ShieldCheck } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material después de comprar?',
    a: 'Acceso digital inmediato por descarga, disponible en minutos tras la confirmación del pago.'
  }, {
    q: '¿Sirve si recién estoy armando mi consultorio?',
    a: 'Sí, está pensado tanto para quien arranca como para quien ya atiende y quiere ordenar su sistema de trabajo.'
  }, {
    q: '¿Los modelos legales sirven para toda Argentina?',
    a: 'Están desarrollados en base al marco legal nacional (Ley 26.061 y Código Civil y Comercial). No reemplazan asesoramiento legal personalizado en casos complejos.'
  }, {
    q: '¿Los 3 bonos están incluidos en ambas ofertas?',
    a: 'Sí, los 3 bonos de consulta rápida están incluidos tanto en el Megapack PRO como en la Edición Total.'
  }, {
    q: '¿Qué diferencia hay con buscar modelos sueltos en internet?',
    a: 'Acá tenés todo integrado, adaptado a consulta infanto-juvenil en Argentina y organizado por tomo, sin tener que armar el rompecabezas vos.'
  }, {
    q: '¿Por qué elegir la Edición Total y no el Megapack PRO?',
    a: 'Si recibís casos con derivación escolar, judicial, o necesitás blindaje legal en consentimientos, la Edición Total te ahorra ese trabajo extra.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí, 7 días para probarlo. Si no te sirve, te devolvemos el 100% sin preguntas.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-10 md:py-20 bg-slate-50 border-t border-slate-100" data-id="element-28">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-blue-50 border border-blue-100 rounded-3xl p-6 md:p-12 text-center mb-12 md:mb-24" data-id="element-30">
          <ShieldCheck className="w-12 h-12 md:w-16 md:h-16 text-blue-600 mx-auto mb-4 md:mb-6" data-id="element-31" />
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3 md:mb-4" data-id="element-32">
            7 DÍAS DE GARANTÍA TOTAL
          </h2>
          <p className="text-sm md:text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-33">
            7 días para probarlo o te devolvemos el 100%.
            <br className="hidden md:block" data-id="element-34" />
            <span className="block mt-2 md:inline md:mt-0" data-id="element-35">
              Descargás el material, lo aplicás en tu próxima consulta. Si no es
              lo que esperabas: sin preguntas, sin formularios, sin drama.
            </span>
          </p>
        </motion.div>

        {/* FAQ Accordion */}
        <div className="mb-12 md:mb-20" data-id="element-36">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 md:mb-10" data-id="element-37">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="space-y-3 md:space-y-4" data-id="element-38">
            {faqs.map((faq, i) => <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} key={i} className="border border-slate-200 rounded-xl overflow-hidden bg-white" data-id="element-39">
                <button onClick={() => setOpen(open === i ? null : i)} className="w-full flex items-center justify-between p-4 md:p-6 bg-white hover:bg-slate-50 transition-colors text-left" data-id="element-40">
                  <span className="font-bold text-slate-900 pr-4 text-sm md:text-base" data-id="element-41">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: open === i ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-42">
                    <ChevronDown className="w-4 h-4 md:w-5 md:h-5 text-slate-400 flex-shrink-0" data-id="element-43" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-44">
                  {open === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} data-id="element-45">
                      <div className="p-4 md:p-6 pt-0 text-slate-600 bg-white border-t border-slate-100 text-xs md:text-base" data-id="element-46">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 text-center text-sm" data-id="element-47">
      <div className="max-w-6xl mx-auto px-4" data-id="element-48">
        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-49">
          <span className="text-2xl" data-id="element-50">🧠</span>
          <span className="font-bold text-white text-lg tracking-tight" data-id="element-51">
            MEGAPACK SALUD MENTAL PEDIÁTRICA PRO
          </span>
        </div>
        <p className="max-w-2xl mx-auto mb-8" data-id="element-52">
          Guía profesional y herramientas clínicas para consultorio de
          psicología infanto-juvenil en Argentina. Porque ordenar tu consulta no
          debería llevarte meses de ensayo y error.
        </p>
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-8" data-id="element-53">
          <a href="mailto:contacto@solucionesya.shop" className="hover:text-white transition-colors" data-id="element-54">
            contacto@solucionesya.shop
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-55">
            @solucionesya.shop
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-56">
            solucionesya.shop
          </a>
        </div>
        <p data-id="element-57">© Solucionesya.shop™ 2026 — Todos los derechos reservados.</p>
      </div>
    </footer>;
}